// extracted by mini-css-extract-plugin
export var core = "Navlist-module--core--71486";
export var textWhite = "Navlist-module--text-white--3d65e";
export var white = "Navlist-module--white--79df7";